import React from "react";
import PropTypes from 'prop-types';
import TitleBar from '../Layout/titleBar';
import { Row, Col } from 'react-flexbox-grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import './proveedores.css';

class ProveedorEdit extends React.Component {
    render() {
        const { proveedor, handleOnSave, handleOnCancel, handleOnChange, error } = this.props;
        return (
            <div className='crearEditarProveedor'>

                {/* menú superior */}
                <TitleBar
                    title={((proveedor?.idProveedor === 0) ? 'Nuevo ' : 'Editar ') + this.props.entidad}
                    handleOnSave={handleOnSave}
                    handleOnBack={handleOnCancel}
                    showSearch={false}
                />

                <Paper className='myBox no-margin'>
                    <Row>
                        <Col md={12}>
                            <TextField 
                                className='myInput'
                                label='Nombre'
                                name='nombreProveedor'
                                fullWidth
                                required
                                value={proveedor.nombreProveedor}
                                onChange={handleOnChange}

                                error={error && error.nombre}
                                helperText={(error && error.nombre) ? error.nombre : ""}
                                InputLabelProps={{ shrink: true }}
                                style={{ margin: "10px", width: "98%", }}
                            />
                        </Col>
                    </Row>
                </Paper>
            </div>
        );
    }
};

ProveedorEdit.propTypes = {
    proveedor: PropTypes.object.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    error: PropTypes.object,
};

ProveedorEdit.defaultProps = {
    proveedor: {},
};

export default ProveedorEdit;